import type { Dispatch } from '@ps/web-core-store';
import { Size } from '@ps/web-core-store';
import { StarsButton, Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { ModalContextValue } from '@swf/components/StarsModal/Context';
import { ModalContext } from '@swf/components/StarsModal/Context';
import Body from '@swf/components/StarsModal/components/Body';
import { select } from '@swf/core/store';

import theme from '../../../themes';
import BaseHeader from '../BaseHeader/BaseHeader';

import { TXTCLI_Close, TXTCLI_My_Games } from './ActiveGames.messages.json';
import styles from './ActiveGames.scss';
import GamesList from './GamesList';
import NoGamesAvailable from './NoGamesAvailable';

const ActiveGames: React.FC = () => {
  const { setStyle } = useContext<ModalContextValue>(ModalContext);
  const { modal } = useDispatch<Dispatch>();
  const games = useSelector(select.activeGames.getGames);

  useEffect(() => {
    setStyle({
      closeOnOverlayClick: true,
      closeOnEsc: true,
      overlayClassName: classNames(theme.darkMode, styles.modalOverlay),
      className: classNames(styles.modalContainer, styles.modalContainerCentered),
      size: Size.SMALL
    });
  }, [setStyle]);

  const handleClose = () => {
    modal.close();
  };

  return (
    <>
      <BaseHeader
        headerClassName={classNames(styles.header)}
        title={<Translation {...TXTCLI_My_Games} />}
      />
      <Body className={styles.body}>
        {games.length ? <GamesList games={games} onAction={handleClose} /> : <NoGamesAvailable />}
        <div className={styles.bodyActionButtons}>
          <StarsButton
            className={styles.button}
            variant="secondary"
            onClick={handleClose}
            translation={TXTCLI_Close}
          />
        </div>
      </Body>
    </>
  );
};

export default ActiveGames;
